var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"c-print"}},[_c('button',{staticClass:"hidden-print-element btn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.print}},[_c('inline-svg',{staticClass:"w-20 h-20",attrs:{"src":'/img/icon-print.svg'}}),_c('span',[_vm._v("Печать")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }